import { Box, Paper } from '@material-ui/core'
import React from 'react'

export default function CardWrapper({ children }) {
  return (
    <Box mb={2}>
      <Paper variant="outlined" elevation={0}>
        <Box p={3}>{children}</Box>
      </Paper>
    </Box>
  )
}
